import React, { Component } from 'react';
import ClientDataSearchSheet from './ClientDataSearchSheet';

class RequestAndReturnedSheet extends Component {
    constructor(props) {
        super(props);
        const { auth } = props;
        const modules = [{
            key: 'clientDataSearchSheet',
            Content: ClientDataSearchSheet,
        }
        ];

        this.modules = modules.filter(item => auth === undefined || auth[item.key] !== false);
    }
    render() {
        const { auth } = this.props;
        const modules = this.modules.map(item => {
            const { key, Content } = item;
            return <Content key={key} auth={auth ? auth[key] : auth} />;
        });
        return (
            <div className="pane">
                {modules}
            </div>
        );
    }
}

export default RequestAndReturnedSheet;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ClientDataSearch/index.js